import React, { Component } from "react"
import { RouteComponentProps } from "react-router-dom"
import { connect } from "react-redux"
import { App } from "../../App"
import { AppState } from "../../store"
import { UserInfo } from "../../services/account/account-rest-interface"
import SprintsTest from "./SprintsTest"
import "./index.css"

const mapStateToProps = ({ account }: AppState) => ({
    userInfo: account.userInfo as UserInfo,
})

const mapDispatchToProps = { }

export interface StoreProps {
    userInfo: UserInfo
}

interface Props {

}

interface State {
    shouldRestoreNavbar: boolean
    testDetails: any
}

type AllProps = Props & StoreProps & RouteComponentProps<any>

/**
 * ACT Sprints are similar to the ACT practice test's look & feel.
 */
export class SprintsTestContainerView extends Component<AllProps, State> {
    constructor(props)  {
        super(props)

        this.state = {
            shouldRestoreNavbar: false,
            testDetails: undefined,
        }
    }

    async componentDidMount() {
        try {
            let newState: any = { }
            if (!App.isNavbarCollapsed()) {
                App.collapseNavbar()
                newState.shouldRestoreNavbar = true
            }
            this.setState(newState)
            App.hideNavbar()
        }
        catch (err) {
            console.error("Failed to load the test details!")
        }
    }

    componentWillUnmount() {
        if (this.state.shouldRestoreNavbar) {
            if (App.isNavbarCollapsed()) {
                App.collapseNavbar(false)
            }
        }
        App.hideNavbar(false)
    }

    handleTestExit = (testName: string) => {
        let {props} = this as any
        props.history.goBack()
    }

    render() {
        let props: any = this.props
        let testId = props.match.params.testId
        let {userInfo} = props

        return (
            <div className="sprints-test-container">
                <SprintsTest userInfo={userInfo} testId={testId} />
            </div>
        )
    }

}


const SprintsTestConnectedContainer = connect<StoreProps, {}, {}, AppState>(mapStateToProps, mapDispatchToProps)(SprintsTestContainerView)

export default (props) => {
    return (
        <SprintsTestConnectedContainer {...props} />
    )
}
